export class ProjectEmailTemplate  {
    constructor(
        public type: string,
        public senderName: string,
        public senderEmail: string,
        public subject: string,
        public body: string,
        public createdAt: Date,
        public updatedAt: Date,
    ) { }

    static fromData(data: any): ProjectEmailTemplate {
        if (data === null || data instanceof ProjectEmailTemplate) {
            return data
        }

        return new ProjectEmailTemplate(
            data.type,
            data.senderName,
            data.senderEmail,
            data.subject,
            data.body,
            data.createdAt,
            data.updatedAt,
        )
    }
}
